const overrideAutocompleteStyles = () => ({
  MuiAutocomplete: {
    styleOverrides: {
      inputRoot: {
        paddingBottom: '7px !important'
      }
    }
  }
})

export default overrideAutocompleteStyles
